import $api from '@/http'

async function bonusMalus(formData) {
    return await $api.get('/mainPublic/bonus-malus/individual', {
        params: {
            isfizliso: formData.isfizliso,
            pin: formData.pin,
            vehicleNumber: formData.vehicleNumber
        }
    })
}

async function certificateInsurance(formData) {
    return await $api.get('/mainPublic/certificate/individual', {
        params: {
            isfizliso: formData.isfizliso,
            pin: formData.pin
        }
    })
}

async function noClaimsCertificate(formData) {
    return await $api.get('/mainPublic/no-claims-certificate/individual', {
        params: {
            fromDate: formData.fromDate,
            toDate: formData.toDate,
            isfizliso: formData.isfizliso,
            pin: formData.pin
        }
    })
}

async function vehicleHistory(formData) {
    return await $api.get('/mainPublic/vehicle-history/by-number', {
        params: {
            vehicleNumber: formData.vehicleNumber,
            win: formData.win
        }
    })
}


export default {
    bonusMalus,
    certificateInsurance,
    noClaimsCertificate,
    vehicleHistory
}

